module.exports = __webpack_public_path__ + "img/interac.6adb99b7.svg";